import gql from "graphql-tag";

export const SUBSCRIPTION_QUERY = gql`
	query Subscription {
		subscription {
			id
			amount
			status
			nextPaymentDate
			cardNumber
			cardBrand
			cardExpirationDate
			productName
		}
	}
`;
